var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import '../index.css';
import '../App.css';
import Checkpoint from './Checkpoint';
import { getNormalizedPosition } from "../Utils/HelperFunctions";
export default function ProgressBarWithCheckpoints(props) {
    var _a, _b, _c, _d, _e;
    var _f = useState(getNormalizedPosition(props.progress, props.maximumValue)), percent = _f[0], setPercent = _f[1];
    useEffect(function () {
        setPercent(getNormalizedPosition(props.progress, props.maximumValue));
    }, [props.progress]);
    var mapCheckpoints = function (checkpoint, index) {
        var _a, _b;
        return _jsx(Checkpoint, { useIcons: props.useIcons, checkpoint: checkpoint, accomplished: getNormalizedPosition(checkpoint.Value, props.maximumValue) <= percent, index: index, position: getNormalizedPosition(checkpoint.Value, props.maximumValue), filledColor: (_a = props.filledCheckpoint) !== null && _a !== void 0 ? _a : '#FFD700', unfilledColor: (_b = props.unfilledCheckpoint) !== null && _b !== void 0 ? _b : '#848484' }, index);
    };
    var unfilledStyle = {
        backgroundColor: (_a = props.unfilledBackground) !== null && _a !== void 0 ? _a : '#D1D3D4',
        width: (_b = props.width) !== null && _b !== void 0 ? _b : '100%',
        height: (_c = props.height) !== null && _c !== void 0 ? _c : ''
    };
    return (_jsxs(_Fragment, { children: [props.text ? _jsx("div", __assign({ className: 'bl-progress-bar-text' }, { children: props.text }), void 0) : null, _jsx("br", {}, void 0), _jsxs("div", __assign({ className: "" + (props.className ? props.className : 'bl-progress-bar'), style: unfilledStyle }, { children: [props.checkpoints.map(mapCheckpoints), _jsx("div", __assign({ className: props.className ? '' : 'bl-progress-bar-progression', style: props.style ? __assign(__assign({}, props.style), { width: percent + "%" }) : props.className ? { width: percent + "%" } : { backgroundColor: (_d = props.filledBackground) !== null && _d !== void 0 ? _d : '#0074d9', width: percent + "%" } }, { children: _jsx("div", __assign({ className: 'bl-progress-bar-value bl-progress-bar-progress-value', style: { float: 'right', marginTop: '25px', color: (_e = props.filledBackground) !== null && _e !== void 0 ? _e : '#0074d9' } }, { children: props.progress }), void 0) }), void 0)] }), void 0)] }, void 0));
}
